<template>
    <el-select :disabled="disabled" :multiple="multiple" :collapse-tags="collapse" :value="value" filterable remote
        :placeholder="queryplace" clearable @input="change" @click.native="handleSelected()"
        :remote-method="remoteMethod">
        <el-option v-for="item in ManagerOperation" :key="item.Id" :label="item.Title" :value="item.Id">
        </el-option>
        <div style="margin-left:50%">
            <el-pagination small layout="prev, pager, next" :total="total" :page-size="size"
                @current-change="handleCurrentChange" @size-change="handleSizeChange">
            </el-pagination>
        </div>
    </el-select>
</template>
    
<script>

import { GetPageListInType } from "../../../api/api";
export default {
    name: "selectProduct",
    props: {
        value: {
            type: String | Number,
            default() {
                return "";
            },
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            },
        },
        multiple: {
            type: Boolean,
            default() {
                return false;
            },
        },
        collapse: {
            type: Boolean,
            default() {
                return false;
            },
        },
        queryplace: {
            type: String,
            default: function () {
                return "请选择产品信息";
            }
        },
        isEnable: {
            //是否筛选启用项目分类，默认是。选择全部默认传值空
            type: Boolean,
            default() {
                return true;
            },
        }
    },
    data() {
        return {
            typeId: "",
            ManagerOperation: [],
            typeSearch: "",//搜索
            total: 0,
            size: 20,
            page: 1,
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.page = val;
            this.getTypeInfoList();
        },
        handleSizeChange(val) {
            this.size = val;
            this.page = 1;
            this.getTypeInfoList();
        },
        remoteMethod(value) {
            this.typeSearch = value;
            this.page = 1;
            this.getTypeInfoList();
        },
        getTypeInfoList() {
            let para = {
                title: this.typeSearch,
                intPageSize: this.size,
                page: this.page
            };
            return GetPageListInType(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.ManagerOperation = res.data.response.data ? res.data.response.data : [];
                return res;
            });
        },
        change(val) {
            this.$emit("input", val);
        },
        // 按钮点击事件
        handleSelected() {
            // 主动触发点击事件
            this.typeSearch = "";
            this.getTypeInfoList();
        },
        check(val) {
            if (this.value != null) {
                var index = this.ManagerOperation.findIndex(s => s.Id == this.value);
                if (index < 0) {
                    //this.typeSearch = val;
                    this.getTypeInfoList();
                }
            }
        }
    },
    mounted() {
        if (this.value) {
            this.typeId = this.value;
            this.typeSearch = this.value;
        }
    },
    watch: {
        "value": function (val) {
            this.check(val);
        }
    },
}
</script>